import React from "react";
import clsx from "clsx";

import styles from "./Map.styles";

const Map = () => {
	const css = styles();

	return (
		<div className={clsx(css.map, "mco-view-component-footer-map")}>
			<img
				alt="Map"
				height={379}
				loading="lazy"
				src="/img/footer-map.png"
				srcSet="/img/footer-map-2x.png 2x"
				width={535}
			/>
		</div>
	);
};

export default Map;
